<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'BANCOERROR.LBL_BANCOERRORES' | translate}}</h1>
  </div>
</div>
<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid contenedor-filtros">
    <div class="col-12 md:col-12 lg:col-12">
      <form [formGroup]="formulario" (ngSubmit)="buscar()" novalidate id="fControles" name="fControles">
        <div class="grid form-group">
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>{{ 'BANCOERROR.LBL_INTEGRACION' | translate }}</label>
              <p-dropdown disableTab  id="integracion" name="integracion" [options]="lisIntegraciones"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
                           formControlName="integracion"
              ></p-dropdown>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>{{ 'BANCOERROR.LBL_TEXTOBUSCAR' | translate }}:</label>
              <input type="text" pInputText id="textoBuscar"
                     name="nomTextoBuscar"
                     autocomplete="off"
                     formControlName="textoBuscar"
                     [maxlength]="500"
                     sin-caracteres-especiales-reactive>
            </div>
          </div>
        </div>

        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!filtrando" class="gap-2">
              <button icon="fa fa-eraser" label="{{'BANCOERROR.LBL_LIMPIAR' | translate }}"
                      type="button" (click)="limpiarFiltros()" class="p-button-secondary"
                      pButton></button>
              <button icon="fa fa-filter" label="{{'BANCOERROR.LBL_BUSCAR' | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="filtrando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6">
      <button type="button" pButton icon="fa fa-plus" (click)="crear()" *ngIf="menu.agregar"
              label="{{ 'BTN_AGREGAR' | translate}}"></button>
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt
               [value]="bancoErrores" selectionMode="single" dataKey="idControl"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="table-break">{{row.integracion}}</td>
            <td class="table-break">{{row.codigo}}</td>
            <td class="table-break">{{row.descripcionUsuario}}</td>
            <td class="table-break">{{row.descripcionTecnica}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-eye" data-toggle="tooltip"
                        title="{{'BANCOERROR.BTN_VISUALIZAR' | translate}}" pButton *ngIf="menu.mostrar"
                        (click)="visualizar(row)"></button>
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="menu.editar"
                        (click)="editar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
